import axios from 'axios';
import constants from '../../config/constants';
import { formResMessage } from '../../utils/commonFunc';
import { showCustomBillReceiptService } from './billing';
import { getReport } from './reports';

export const GET_ALL_ADMISSIONS = 'GET_ALL_ADMISSIONS';
export const GET_ADMISSION = 'GET_ADMISSION';
export const GET_ADMISSION_BY_NUMBER = 'GET_ADMISSION_BY_NUMBER';
export const GET_ADMISSION_BY_NUMBER_AND_ID = 'GET_ADMISSION_BY_NUMBER_AND_ID';

//= ========== Reducer call functions begin ===========//
export const getAllAdmissions = admissionData => ({
  type: GET_ALL_ADMISSIONS,
  admissionData,
});

export const getAdmission = admission => ({
  type: GET_ADMISSION,
  admission,
});

export const getAdmissionByNumber = admissionByNumber => ({
  type: GET_ADMISSION_BY_NUMBER,
  admissionByNumber,
});

export const getAdmissionByNumberAndId = admissionByNumberAndId => ({
  type: GET_ADMISSION_BY_NUMBER_AND_ID,
  admissionByNumberAndId,
});
//= ========== Reducer call functions begin ===========//

//= ========== User routing begin ===========//
export const fetchAllAdmissionsService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/all-admission-form/${data.status}${constants.makeParams(data.pageParams)}`,
      constants.setHeader(data.token)
    );
    return dispatch(getAllAdmissions(res.data));
  } catch (err) {
    console.error(err.response);
  }
};

export const saveAdmissionService = data => () => {
  return axios.post(`${constants.API_BASE_URL}/api/admission-form`, data.postData, constants.setHeader(data.token));
};

export const fetchAdmissionService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/admission-form/${data.admissionId}`,
    constants.setHeader(data.token)
  );
  return dispatch(getAdmission(res.data));
};

export const deleteAdmissionService = data => () => {
  return axios.delete(
    `${constants.API_BASE_URL}/api/admission/delete-school-admission/${data.admissionId}`,
    constants.setHeader(data.token)
  );
};

// Non-auth admission API's
export const updateAdmissionService = data => () => {
  return axios.put(
    `${constants.API_BASE_URL}/api/update-admission-form/${data.admissionId}`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const fetchAdmissionByNumberService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/auth/my-admission-form/${data.schoolId}/${data.phoneNumber}`,
    constants.setHeader(data.token)
  );
  return dispatch(getAdmissionByNumber(res.data));
};

export const fetchAdmissionByNumberAndIdService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/auth/view-admission-form/${data.schoolId}/${data.phoneNumber}/${data.admissionId}`,
    constants.setHeader(data.token)
  );
  return dispatch(getAdmissionByNumberAndId(res.data));
};
//= ========== User routing end ===========//

// Admission payment (a custom bill linked to the admission). The backend takes school, batch and payer from the
// admission itself, so only the amount and note are sent. billName is fixed and never shown to the user.
export const ADMISSION_BILL_NAME = 'Admission fee';

export const addAdmissionBillService = ({ admissionId, amount, note, token }) => {
  const postData = { billName: ADMISSION_BILL_NAME, amount: Number(amount) };
  if (note && note.trim()) postData.description = note.trim();
  return axios.post(
    `${constants.API_BASE_URL}/api/admission-form/${admissionId}/bill`,
    postData,
    constants.setHeader(token)
  );
};

// The admission's payment receipt: the custom bill's receipt, labelled with the application number.
export const showAdmissionReceiptService = ({ applicationNo, ...params }) =>
  showCustomBillReceiptService({ ...params, label: applicationNo });

// The plain (blank) admission form of the school, to print and hand out: opened in the report viewer, whose toolbar prints or saves it.
export const showPlainAdmissionFormService =
  ({ schoolId, token }) =>
  async dispatch => {
    try {
      const res = await axios.get(`${constants.API_BASE_URL}/api/admission-form/print/${schoolId}`, {
        headers: constants.setHeader(token).headers,
        responseType: 'arraybuffer',
      });
      dispatch(getReport({ fileData: res.data, headingName: 'Admission form' }));
      return true;
    } catch (err) {
      // The error body comes back as an ArrayBuffer because of responseType - decode it so the message is readable.
      const data = err?.response?.data;
      if (data instanceof ArrayBuffer) {
        try {
          err.response.data = JSON.parse(new TextDecoder('utf-8').decode(data));
        } catch {
          err.response.data = null;
        }
      }
      throw new Error(formResMessage(err) || 'Unable to open the admission form. Please try again.');
    }
  };
